import type { KhoaDich } from '../../i18n/types';
import type { LogoSlot, TruongDoi } from './types';

export const TEN_TOI_DA = 100;
export const VIET_TAT_TOI_DA = 12;

/** Trần dung lượng ảnh; server kiểm lại và trả `413` (mã `INVALID_ARGUMENT`). */
export const LOGO_TOI_DA_BYTE = 2 * 1024 * 1024;

/**
 * Chỉ PNG và JPEG. **Không** SVG (chứa được script) và không WebP: JDK của tenant-service không giải mã được WebP
 * để mã hoá lại, nên server từ chối `415`.
 */
export const LOGO_KIEU_CHO_PHEP: readonly string[] = ['image/png', 'image/jpeg'];

export const LOGO_ACCEPT = LOGO_KIEU_CHO_PHEP.join(',');

/** Trang lịch sử mỗi lần tải. */
export const MOT_TRANG_LICH_SU = 20;

export interface ODuongAnh {
  slot: LogoSlot;
  nhan: KhoaDich;
  mo: KhoaDich;
  /** `true` thì khung xem trước dùng nền tối cố định, để logo sáng không chìm. */
  nenToi: boolean;
}

export const CAC_O_ANH: readonly ODuongAnh[] = [
  { slot: 'light', nhan: 'hoSoToChuc.logoSang', mo: 'hoSoToChuc.logoSangMo', nenToi: false },
  { slot: 'dark', nhan: 'hoSoToChuc.logoToi', mo: 'hoSoToChuc.logoToiMo', nenToi: true },
  { slot: 'favicon', nhan: 'hoSoToChuc.favicon', mo: 'hoSoToChuc.faviconMo', nenToi: false },
];

/** Nhãn của từng trường trong lịch sử thay đổi. */
export const TRUONG_KHOA: Record<TruongDoi, KhoaDich> = {
  display_name: 'hoSoToChuc.truong.tenHienThi',
  short_name: 'hoSoToChuc.truong.tenVietTat',
  logo_light: 'hoSoToChuc.truong.logoSang',
  logo_dark: 'hoSoToChuc.truong.logoToi',
  favicon: 'hoSoToChuc.truong.favicon',
};
